"use client";

import * as React from "react";
import { Button } from "@mui/material";

type Props = {
  isAuthed: boolean;
  appBase: string;
  apiOrigin: string;
};

const HeaderButtons: React.FC<Props> = ({ isAuthed, appBase, apiOrigin }) => {
  const LinkBtn = ({
    href,
    children,
    variant = "text",
    pill = false,
  }: {
    href: string;
    children: React.ReactNode;
    variant?: "text" | "contained" | "outlined";
    pill?: boolean;
  }) => (
    <Button
      component="a"
      href={href}
      color="inherit"
      variant={variant}
      sx={{
        mx: 1.25,
        ...(pill && {
          color: "white",
          bgcolor: "secondary.main",
          borderRadius: "9999px",
          px: 2.25,
          fontWeight: 600,
          "&:hover": { bgcolor: "secondary.dark" },
        }),
      }}
    >
      {children}
    </Button>
  );

  if (isAuthed) {
    return (
      <>
        <LinkBtn href={`${appBase}/feed`} variant="contained" pill>
          Feed
        </LinkBtn>
        <LinkBtn href={`${appBase}/profile`}>Profile</LinkBtn>
        <Button
          component="a"
          href={`${apiOrigin}/auth/logout`}
          color="inherit"
          variant="text"
          sx={{ mx: 1.25 }}
        >
          Logout
        </Button>
      </>
    );
  }

  // Logged out — user is already on the auth page, no buttons needed
  return null;
};

export default HeaderButtons;
